import actionTypes from '../constants/action-types';

const mappedHTML = (state = null, action) => {
  if (action.type !== actionTypes.CONNECT_MAPPED_HTML) return state;

  return action.payload.mappedHTML;
};

export default mappedHTML;
